import { Component } from '@angular/core';

@Component({
  selector: 'app-aludyco-mfg-co',
  templateUrl: './aludyco-mfg-co.component.html',
  styleUrls: ['./aludyco-mfg-co.component.scss']
})
export class AludycoMfgCoComponent {

}
